import axios from 'axios';

// Create axios instance with base configuration
const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Request interceptor
axiosClient.interceptors.request.use(
  (config) => {
    // You can add auth tokens here if needed
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// Mock API functions
export const api = {
  // Get nearby partners
  getPartners: async (lat, lng) => {
    // Mock data for now
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          partners: [
            {
              id: 1,
              name: 'Dr. Priya Sharma',
              image: 'https://randomuser.me/api/portraits/women/44.jpg',
              distance: 1.2,
              rating: 4.8,
              reviews: 156,
              available: true,
              specialty: 'Ayurvedic Cleansing',
            },
            {
              id: 2,
              name: 'Dr. Amit Patel',
              image: 'https://randomuser.me/api/portraits/men/32.jpg',
              distance: 2.5,
              rating: 4.9,
              reviews: 203,
              available: true,
              specialty: 'Holistic Detox',
            },
            {
              id: 3,
              name: 'Dr. Neha Gupta',
              image: 'https://randomuser.me/api/portraits/women/68.jpg',
              distance: 3.8,
              rating: 4.7,
              reviews: 98,
              available: false,
              specialty: 'Natural Therapy',
            },
          ],
        });
      }, 1000);
    });
  },

  // Create booking
  createBooking: async (bookingData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          success: true,
          bookingId: Math.random().toString(36).substr(2, 9),
          message: 'Booking confirmed successfully',
          booking: {
            ...bookingData,
            confirmationNumber: `CT${Date.now()}`,
            scheduledDate: new Date(Date.now() + 86400000).toISOString(),
          },
        });
      }, 1500);
    });
  },

  // Get user details
  getUser: async (userId) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          id: userId,
          name: 'Guest User',
          bookings: [],
        });
      }, 500);
    });
  },

  // Get reviews
  getReviews: async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          reviews: [
            {
              id: 1,
              user: 'Anjali K.',
              rating: 5,
              comment: 'Amazing experience! Felt rejuvenated after the therapy.',
              date: '2024-10-15',
            },
            {
              id: 2,
              user: 'Rahul M.',
              rating: 5,
              comment: 'Best detox therapy I have tried. Highly recommend!',
              date: '2024-10-20',
            },
          ],
        });
      }, 800);
    });
  },
};

export default axiosClient;
